/* jshint esversion: 6 */
import render from "common/render-component";
import FilterSelect from "product-pages/filter-select";
import $ from "jquery";

$(".adwerx__filter-select").each((_, element) => {
  render(FilterSelect, element);
});
